import { PencilLineIcon } from '@repo/icons';
import { type TestId } from '@repo/test-id';
import { Button, Card } from '@repo/ui';

interface Props {
  name: string;
  email: string;
  onEdit: () => void;
  testId: TestId;
}

export default function ProfileCard({ name, email, onEdit, testId }: Props) {
  return (
    <Card className="mx-4 -mt-8 shrink-0 p-4" wrapperClass="flex flex-row items-center justify-between" testId={testId}>
      <div className="flex flex-col gap-0.5">
        <span className="text-heading text-base font-semibold" data-testid={testId.append('name')}>
          {name}
        </span>
        <span className="text-body-subtle text-sm" data-testid={testId.append('email')}>
          {email}
        </span>
      </div>

      <Button
        color="tertiary"
        size="lg"
        leftIcon={PencilLineIcon}
        iconOnly
        className="rounded-full"
        onClick={onEdit}
        testId={testId.append('edit')}
      />
    </Card>
  );
}
